import { FileText, type LucideIcon } from "lucide-react";
import { cn } from "@tellescope/utils";

interface FilePreviewTileProps {
  variant?: "icon" | "loading";
  icon?: LucideIcon;
  iconClassName?: string;
  className?: string;
}

/**
 * The fixed-size slot every file preview occupies, whether or not the file has a renderable image.
 * Keeping the icon and loading states the same footprint as a thumbnail is what stops rows in a
 * file list from changing height as their previews resolve.
 */
export const FilePreviewTile = ({
  variant = "icon",
  icon: Icon = FileText,
  iconClassName,
  className,
}: FilePreviewTileProps) => (
  <div
    className={cn(
      "h-10 w-10 flex-shrink-0 rounded flex items-center justify-center bg-muted",
      variant === "loading" && "animate-pulse",
      className
    )}
  >
    {variant === "icon" && <Icon className={cn("h-4 w-4 text-muted-foreground", iconClassName)} />}
  </div>
);
